import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import {
  placeholderNoOptions,
  placeholderText,
} from "../../../../shared/helpers/placeHolders";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import makeAnimated from "react-select/animated";
import { phoneTypeEnum } from "../../../../shared/selectors/phoneTypeEnum";
import { to_ISelect_Enum } from "../../../../shared/mutator/dataTransformSelect";
import { customStyles } from "../custom-selector-styles";
import Select from "react-select";
import { phoneType } from "../../../../shared/model/enumerations/phone-type.model";
interface IProps {
  formik: any;
  showErrorsInputs: boolean;
}

const animatedComponents = makeAnimated();

// eslint-disable-next-line complexity
export const ContactData = (props: IProps) => {
  const { formik, showErrorsInputs } = props;
  return (
    <>
      {/* DATOS DE CONTACTO */}
      <Row className="title-form not-first-title">Datos de contacto</Row>
      <Label
        className={`text-subtitle ${
          (showErrorsInputs ||
            formik.touched?.contactInformation?.partMobileNumber ||
            formik.touched?.contactInformation?.countryCode ||
            formik.touched?.contactInformation?.areaCode) &&
          (formik.errors?.contactInformation?.partMobileNumber ||
            formik.errors?.contactInformation?.countryCode ||
            formik.errors?.contactInformation?.areaCode) &&
          "text-danger"
        }`}
      >
        Teléfono móvil*
      </Label>
      <Row className="container-inputs-form">
        <Col md="2">
          <FormGroup>
            <Label
              id="countryCodeLabel"
              for="contactInformation.countryCode"
              className={
                (showErrorsInputs ||
                  formik.touched?.contactInformation?.countryCode) &&
                formik.errors?.contactInformation?.countryCode &&
                "text-danger"
              }
            >
              Código de país
            </Label>
            <PhoneInput
              inputProps={{
                name: "contactInformation.countryCode",
                disabled: true,
              }}
              country={"ar"}
              inputClass="select-country-styles"
              buttonClass="select-country-dropdown-styles"
              onChange={formik.handleChange("contactInformation.countryCode")}
              onBlur={formik.handleBlur("contactInformation.countryCode")}
            />
            {(showErrorsInputs ||
              formik.touched?.contactInformation?.countryCode) &&
              formik.errors?.contactInformation?.countryCode && (
                <div className="invalid-feedback">
                  {formik.errors.contactInformation.countryCode}
                </div>
              )}
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <Label
              id="areaCodeLabel"
              for="contactInformation.areaCode"
              className={
                (showErrorsInputs ||
                  formik.touched?.contactInformation?.areaCode) &&
                formik.errors?.contactInformation?.areaCode &&
                "text-danger"
              }
            >
              Código de área
            </Label>
            <Input
              type="text"
              name="contactInformation.areaCode"
              onChange={formik.handleChange("contactInformation.areaCode")}
              onBlur={formik.handleBlur("contactInformation.areaCode")}
              value={formik.values.contactInformation.areaCode}
              className={`form-control ${
                (showErrorsInputs ||
                  formik.touched?.contactInformation?.areaCode) &&
                formik.errors?.contactInformation?.areaCode &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
            />
            {(showErrorsInputs ||
              formik.touched?.contactInformation?.areaCode) &&
            formik.errors?.contactInformation?.areaCode ? (
              <div className="invalid-feedback">
                {formik.errors.contactInformation.areaCode}
              </div>
            ) : (
              <Label className="text-phone">Código de área (sin 0)</Label>
            )}
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <Label
              id="partMobileNumberLabel"
              for="contactInformation.partMobileNumber"
              className={
                (showErrorsInputs ||
                  formik.touched?.contactInformation?.partMobileNumber) &&
                formik.errors?.contactInformation?.partMobileNumber &&
                "text-danger"
              }
            >
              Número de teléfono
            </Label>
            <Input
              type="text"
              name="contactInformation.partMobileNumber"
              onChange={formik.handleChange(
                "contactInformation.partMobileNumber",
              )}
              onBlur={formik.handleBlur("contactInformation.partMobileNumber")}
              value={formik.values.contactInformation.partMobileNumber}
              className={`form-control ${
                (showErrorsInputs ||
                  formik.touched?.contactInformation?.partMobileNumber) &&
                formik.errors?.contactInformation?.partMobileNumber &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
            />
            {(showErrorsInputs ||
              formik.touched?.contactInformation?.partMobileNumber) &&
            formik.errors?.contactInformation?.partMobileNumber ? (
              <div className="invalid-feedback">
                {formik.errors.contactInformation.partMobileNumber}
              </div>
            ) : (
              <Label className="text-phone">Número de móvil (con el 15)</Label>
            )}
          </FormGroup>
        </Col>
      </Row>

      <Row className="container-inputs-form">
        <Col md="6">
          <FormGroup>
            <Label
              id="mailLabel"
              for="person.mail"
              className={
                (showErrorsInputs || formik.touched?.person?.mail) &&
                formik.errors?.person?.mail &&
                "text-danger"
              }
            >
              Correo personal*
            </Label>
            <Input
              type="text"
              name="person.mail"
              onChange={formik.handleChange("person.mail")}
              onBlur={formik.handleBlur("person.mail")}
              value={formik.values.person.mail}
              className={`form-control ${
                (showErrorsInputs || formik.touched?.person?.mail) &&
                formik.errors?.person?.mail &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
              disabled={
                formik.values?.id && formik.values.id !== 0 ? true : false
              }
            />
            {(showErrorsInputs || formik.touched?.person?.mail) &&
              formik.errors?.person?.mail && (
                <div className="invalid-feedback">
                  {formik.errors.person.mail}
                </div>
              )}
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <Label id="linkedinLabel" for="contactInformation.linkedin">
              Linkedin
            </Label>
            <Input
              type="text"
              name="contactInformation.linkedin"
              onChange={formik.handleChange("contactInformation.linkedin")}
              onBlur={formik.handleBlur("contactInformation.linkedin")}
              value={formik.values?.contactInformation?.linkedin || ""}
              className={`form-control`}
              placeholder={placeholderText()}
            />
          </FormGroup>
        </Col>
      </Row>

      <Label
        className={`text-subtitle ${
          (showErrorsInputs ||
            formik.touched?.contactInformation?.partAlternativePhoneNumber ||
            formik.touched?.contactInformation?.alternativeCountryCode ||
            formik.touched?.contactInformation?.alternativeAreaCode) &&
          (formik.errors?.contactInformation?.partAlternativePhoneNumber ||
            formik.errors?.contactInformation?.alternativeCountryCode ||
            formik.errors?.contactInformation?.alternativeAreaCode) &&
          "text-danger"
        }`}
      >
        Teléfono alternativo*
      </Label>
      <Row className="container-inputs-form">
        <Col md="2">
          <FormGroup>
            <Label
              id="phoneTypeLabel"
              for="person.phoneType"
              className={
                (formik.touched?.contactInformation?.phoneType ||
                  showErrorsInputs) &&
                (formik.errors?.contactInformation?.phoneType ||
                  formik.errors?.contactInformation?.document)
                  ? "text-danger"
                  : ""
              }
            >
              Tipo
            </Label>
            <Col>
              <Select
                name="contactInformation.phoneType"
                placeholder={""}
                noOptionsMessage={() => placeholderNoOptions()}
                components={animatedComponents}
                options={phoneTypeEnum()}
                value={to_ISelect_Enum(
                  formik.values.contactInformation.phoneType,
                  phoneTypeEnum(),
                )}
                onChange={(e: any) => {
                  formik.setFieldValue("contactInformation.phoneType", e.value);
                }}
                onBlur={formik.handleBlur("contactInformation.phoneType")}
                className={`select-postulate ${
                  (formik.touched?.contactInformation?.phoneType ||
                    showErrorsInputs) &&
                  formik.values?.contactInformation?.phoneType === null &&
                  "is-invalid"
                }`}
                styles={customStyles}
              />
              {(formik.touched?.contactInformation?.phoneType ||
                showErrorsInputs) &&
                formik.values?.contactInformation?.phoneType === null && (
                  <div className="invalid-feedback">
                    {formik.errors.contactInformation.phoneType}
                  </div>
                )}
            </Col>
          </FormGroup>
        </Col>
        <Col md="2">
          <FormGroup>
            <Label
              id="alternativeCountryCodeLabel"
              for="contactInformation.alternativeCountryCode"
              className={
                (showErrorsInputs ||
                  formik.touched?.contactInformation?.alternativeCountryCode) &&
                formik.errors?.contactInformation?.alternativeCountryCode &&
                "text-danger"
              }
            >
              Código de país
            </Label>
            <PhoneInput
              inputProps={{
                name: "contactInformation.alternativeCountryCode",
                disabled: true,
              }}
              country={"ar"}
              inputClass="select-country-styles"
              buttonClass="select-country-dropdown-styles"
              onChange={formik.handleChange(
                "contactInformation.alternativeCountryCode",
              )}
              onBlur={formik.handleBlur(
                "contactInformation.alternativeCountryCode",
              )}
            />
            {(showErrorsInputs ||
              formik.touched?.contactInformation?.alternativeCountryCode) &&
              formik.errors?.contactInformation?.alternativeCountryCode && (
                <div className="invalid-feedback">
                  {formik.errors.contactInformation.alternativeCountryCode}
                </div>
              )}
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <Label
              id="alternativeAreaCoderLabel"
              for="contactInformation.alternativeAreaCode"
              className={
                (showErrorsInputs ||
                  formik.touched?.contactInformation?.alternativeAreaCode) &&
                formik.errors?.contactInformation?.alternativeAreaCode &&
                "text-danger"
              }
            >
              Código de área
            </Label>
            <Input
              type="text"
              name="contactInformation.alternativeAreaCode"
              onChange={formik.handleChange(
                "contactInformation.alternativeAreaCode",
              )}
              onBlur={formik.handleBlur(
                "contactInformation.alternativeAreaCode",
              )}
              value={formik.values.contactInformation.alternativeAreaCode}
              className={`form-control ${
                (showErrorsInputs ||
                  formik.touched?.contactInformation?.alternativeAreaCode) &&
                formik.errors?.contactInformation?.alternativeAreaCode &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
            />
            {(showErrorsInputs ||
              formik.touched?.contactInformation?.alternativeAreaCode) &&
            formik.errors?.contactInformation?.alternativeAreaCode ? (
              <div className="invalid-feedback">
                {formik.errors.contactInformation.alternativeAreaCode}
              </div>
            ) : (
              <Label className="text-phone">
                {formik.values?.contactInformation?.phoneType ===
                phoneType.Movil
                  ? "Código de área (sin 0)"
                  : "Código de área (con 0)"}
              </Label>
            )}
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <Label
              id="partAlternativePhoneNumberLabel"
              for="contactInformation.partAlternativePhoneNumber"
              className={
                (showErrorsInputs ||
                  formik.touched?.contactInformation
                    ?.partAlternativePhoneNumber) &&
                formik.errors?.contactInformation?.partAlternativePhoneNumber &&
                "text-danger"
              }
            >
              Número de teléfono
            </Label>
            <Input
              type="text"
              name="contactInformation.partAlternativePhoneNumber"
              onChange={formik.handleChange(
                "contactInformation.partAlternativePhoneNumber",
              )}
              onBlur={formik.handleBlur(
                "contactInformation.partAlternativePhoneNumber",
              )}
              value={
                formik.values.contactInformation.partAlternativePhoneNumber
              }
              className={`form-control ${
                (showErrorsInputs ||
                  formik.touched?.contactInformation
                    ?.partAlternativePhoneNumber) &&
                formik.errors?.contactInformation?.partAlternativePhoneNumber &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
            />
            {(showErrorsInputs ||
              formik.touched?.contactInformation?.partAlternativePhoneNumber) &&
            formik.errors?.contactInformation?.partAlternativePhoneNumber ? (
              <div className="invalid-feedback">
                {formik.errors.contactInformation.partAlternativePhoneNumber}
              </div>
            ) : (
              <Label className="text-phone">
                {formik.values?.contactInformation?.phoneType ===
                phoneType.Movil
                  ? "Número de móvil (con el 15)"
                  : ""}
              </Label>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row className="container-inputs-form">
        <Col>
          <FormGroup>
            <Label
              id="contactAlternativeNameLabel"
              for="contactInformation.contactAlternativeName"
              className={
                (showErrorsInputs ||
                  formik.touched?.contactInformation?.contactAlternativeName) &&
                formik.errors?.contactInformation?.contactAlternativeName &&
                "text-danger"
              }
            >
              Nombre de contacto alternativo*
            </Label>
            <Input
              type="text"
              name="contactInformation.contactAlternativeName"
              onChange={formik.handleChange(
                "contactInformation.contactAlternativeName",
              )}
              onBlur={formik.handleBlur(
                "contactInformation.contactAlternativeName",
              )}
              value={formik.values.contactInformation.contactAlternativeName}
              className={`form-control ${
                formik.touched?.contactInformation?.contactAlternativeName &&
                formik.errors?.contactInformation?.contactAlternativeName &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
            />
            {(formik.touched?.contactInformation?.contactAlternativeName ||
              showErrorsInputs) &&
              formik.errors?.contactInformation?.contactAlternativeName && (
                <div className="invalid-feedback">
                  {formik.errors.contactInformation.contactAlternativeName}
                </div>
              )}
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};
